export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_hxJdOrderNo') || '采购单号',
    field: 'hxJdOrderNo',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_hxShipmentJdNo') || '计划单号',
    field: 'hxShipmentJdNo',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
  },

  {
    title: that.$l('table_label_orderProperties') || '订单属性',
    field: 'orderProperties',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
  },

  {
    title: that.$l('table_label_jdOrderStatus') || '订单状态',
    field: 'jdOrderStatus',
    minWidth: 100,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_hxShipmentJdStatus') || '计划状态',
    field: 'hxShipmentJdStatus',
    minWidth: 120,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
    slots: { default: 'status' },
  },

  {
    title: that.$l('table_label_carNumberPlate') || '车牌号',
    field: 'carNumberPlate',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_vehicleModel') || '车型',
    field: 'vehicleModel',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_jdDc') || '配送中心',
    field: 'jdDc',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_jdWh') || '京东仓库',
    field: 'jdWh',
    width: 200,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_whAddress') || '京东仓库详细地址',
    field: 'whAddress',
    minWidth: 250,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_whContact') || '收货负责人',
    field: 'whContact',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_whContactPhone') || '收货电话',
    field: 'whContactPhone',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_jdPurchaser') || '采购员',
    field: 'jdPurchaser',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_jdCreator') || '建单人',
    field: 'jdCreator',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
  },

  {
    title: that.$l('table_label_jdPurchaserTime') || '订购时间',
    field: 'jdPurchaserTime',
    headerAlign: 'center',
    align: 'center',
    minWidth: 170,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_jdInStockTime') || '入库时间',
    field: 'jdInStockTime',
    headerAlign: 'center',
    align: 'center',
    minWidth: 170,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_jdAppointmentTime') || '预约时间',
    field: 'jdAppointmentTime',
    headerAlign: 'center',
    align: 'center',
    minWidth: 170,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_jdCloseTime') || '预计关单时间',
    field: 'jdCloseTime',
    headerAlign: 'center',
    align: 'center',
    minWidth: 170,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_remark') || '备注',
    field: 'remark',
    minWidth: 280,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_totCtnQty') || '总箱数',
    field: 'totCtnQty',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_totFclCtnQty') || '整箱箱数',
    field: 'totFclCtnQty',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_totTailCtnQty') || '尾箱箱数',
    field: 'totTailCtnQty',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_totPurchaseQty') || '产品总数',
    field: 'totPurchaseQty',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_totPurchaseAmount') || '总采购金额',
    field: 'totPurchaseAmount',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_totCtnCbm') || '总纸箱体积(立方米)',
    field: 'totCtnCbm',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_totCtnGrossWeight') || '总箱毛重(kg)',
    field: 'totCtnGrossWeight',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_totCtnNetWeight') || '总箱净重(kg)',
    field: 'totCtnNetWeight',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_totActualQty') || '实收产品总数量',
    field: 'totActualQty',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_totActualAmount') || '实收总金额',
    field: 'totActualAmount',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_currencyUnit') || '货币单位',
    field: 'currencyUnit',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 170,
    showHeaderOverflow: true,
    slots: { default: 'createInfo' },
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 170,
    showHeaderOverflow: true,
    slots: { default: 'modifyInfo' },
  },
]
